export const PRE_PAYMENT_REPORT_ENDPOINT = `report/prepayment`;
